import React from 'react'

function Nav() {
  return (
    <nav class="wrapper top-wrapper">
        <div class="container">
            <div id="top-links" class="nav pull-right">
                <ul class="list-inline">
                    <li><a href="mailto:sales@technowebsolutions.com"><i class="fa fa-envelope"></i> </a> <span class="hidden-xs hidden-sm hidden-md">sales@technowebsolutions.com</span></li>
                    <li><span class="hidden-xs hidden-sm hidden-md">Follow Us On</span></li>
                    <li class="ico-social ico-fb"><a href="https://www.facebook.com/technowebsolution" target="_blank"><i class="fa fa-facebook"></i></a></li>
                    <li class="ico-social ico-fb"><a href="http://twitter.com/technowebsol" target="_blank"><i class="fa fa-twitter"></i></a></li>
                    <li class="ico-social ico-fb"><a href="http://in.linkedin.com/in/technowebsol" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                </ul>
            </div>
        </div>
    </nav>
  )
}

export default Nav